import { useEffect, useMemo, useRef, useState } from "react";
import { postAxios } from "../../util/apiCall";
import { noFormat, formatDate, today } from "../../util/formatDate";
import moment from "moment";
import axios from "axios";
import { Html5Qrcode } from "html5-qrcode";

export const TROUBLE_TYPES = [
  "Mold",
  "Mesin",
  "Material",
  "Produk NG",
  "Produk Masih Disetting",
  "Lainnya",
];

export const usePatrolQc = () => {
  const dataUser = JSON.parse(localStorage.getItem("auth"));

  const ref = useRef(null);
  const scannerRef = useRef(null);

  const [subMenu, setSubMenu] = useState("patrol");
  const [errMsg, setErrMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isScanning, setIsScanning] = useState(false);
  const [dataQrMesin, setDataQrMesin] = useState();
  const [dataPatrol, setDataPatrol] = useState();

  // form patrol
  const [shiftPatrol, setShiftPatrol] = useState("");
  const [mesinPick, setMesinPick] = useState("");
  const [hasTrouble, setHasTrouble] = useState(false);
  const [troubleType, setTroubleType] = useState("");
  const [troubleDesc, setTroubleDesc] = useState("");

  // filter history
  const [shiftHistoryPatrol, setShiftHistoryPatrol] = useState("");
  const [mesinPatrol, setMesinPatrol] = useState("");
  const [datePatrolQc, setDatePatrolQc] = useState(today);
  const [onlyTrouble, setOnlyTrouble] = useState(false);

  const sortedMesin = useMemo(
    () =>
      dataQrMesin
        ? [...dataQrMesin].sort((a, b) => Number(a.mesin) - Number(b.mesin))
        : [],
    [dataQrMesin]
  );

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getMesin`,
      { tim: dataUser.tim },
      dataUser.auth,
      setDataQrMesin,
      ""
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (subMenu !== "history") return;
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getPatrol`,
      {
        tim: dataUser.tim,
        shift: shiftHistoryPatrol,
        mesin: mesinPatrol,
        onlyTrouble,
        date: moment(datePatrolQc).utcOffset("+0700").format("YYYY-MM-DD"),
      },
      dataUser.auth,
      setDataPatrol,
      ""
    );
    // eslint-disable-next-line
  }, [subMenu, shiftHistoryPatrol, datePatrolQc, mesinPatrol, onlyTrouble]);

  // reset detail trouble saat dimatikan
  const toggleTrouble = (value) => {
    if (value !== hasTrouble) {
      setTroubleType("");
      setTroubleDesc("");
    }
    setHasTrouble(value);
    setErrMsg("");
  };

  const stopScanner = async () => {
    const scanner = scannerRef.current;
    if (scanner) {
      try {
        if (scanner.isScanning) await scanner.stop();
        scanner.clear();
      } catch (e) {
        // abaikan
      }
    }
    scannerRef.current = null;
    setIsScanning(false);
  };

  useEffect(() => () => stopScanner(), []);

  const validateForm = () => {
    if (!shiftPatrol) return "Pilih shift terlebih dahulu.";
    if (!mesinPick) return "Pilih nomor mesin terlebih dahulu.";
    if (hasTrouble) {
      if (!troubleType) return "Pilih jenis trouble.";
      if (!troubleDesc.trim()) return "Isi keterangan trouble.";
    }
    return "";
  };

  const resetForm = () => {
    setMesinPick("");
    setHasTrouble(false);
    setTroubleType("");
    setTroubleDesc("");
  };

  const handlePickLaporan = async () => {
    setSuccessMsg("");
    const validation = validateForm();
    if (validation) {
      setErrMsg(validation);
      return;
    }
    setErrMsg("");

    const find =
      dataQrMesin && dataQrMesin.find((o) => o.id_mesin === mesinPick);
    if (!find) {
      setErrMsg("Data mesin tidak ditemukan.");
      return;
    }

    await stopScanner();
    const html5QrCode = new Html5Qrcode("patrol");
    scannerRef.current = html5QrCode;
    let handled = false;

    const onSuccess = async (decodedText) => {
      if (handled) return;
      handled = true;

      if (find.id_mesin !== decodedText) {
        await stopScanner();
        setErrMsg("QR Code tidak cocok dengan mesin yang dipilih!");
        return;
      }

      try {
        html5QrCode.pause();
      } catch (e) {
        // abaikan
      }

      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_ENDPOINT}/submitPatrol`,
          {
            tim: dataUser.tim,
            name: dataUser.name,
            timestamp: noFormat,
            filterDate: formatDate,
            shift: shiftPatrol,
            id_mesin: find.id_mesin,
            mesin: find.mesin,
            isTrouble: hasTrouble,
            troubleType: hasTrouble ? troubleType : "",
            troubleDesc: troubleDesc.trim(),
          },
          { headers: { Authorization: `Bearer ${dataUser.auth}` } }
        );
        await stopScanner();
        if (data.data === 200) {
          setSuccessMsg(
            hasTrouble
              ? `Patrol Mesin ${find.mesin} tersimpan dengan FLAG TROUBLE.`
              : `Patrol Mesin ${find.mesin} tersimpan. Kondisi normal.`
          );
          resetForm();
        } else {
          setErrMsg(data.message || "Patrol belum berhasil disimpan.");
        }
      } catch (e) {
        await stopScanner();
        setErrMsg("Gagal menghubungi server. Coba scan ulang.");
      }
    };

    try {
      setIsScanning(true);
      await html5QrCode.start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 250, height: 250 } },
        onSuccess,
        () => {}
      );
    } catch (e) {
      setIsScanning(false);
      setErrMsg("Kamera tidak dapat dibuka. Periksa izin kamera.");
    }
  };

  const handleSubMenuHistoryPatrol = async () => {
    await stopScanner();
    setSubMenu("history");
  };

  // kembalikan semua filter history ke nilai default
  const resetHistoryFilter = () => {
    setShiftHistoryPatrol("");
    setMesinPatrol("");
    setDatePatrolQc(today);
    setOnlyTrouble(false);
  };

  // true kalau ada filter yang berbeda dari default
  const isFilterChanged =
    shiftHistoryPatrol !== "" ||
    mesinPatrol !== "" ||
    datePatrolQc !== today ||
    onlyTrouble;

  // server mengirim { data: { data: [...] } }, postAxios menyimpan field "data"
  const historyRows = (dataPatrol && dataPatrol.data) || [];
  const summary = {
    total: historyRows.length,
    trouble: historyRows.filter((r) => r.isTrouble === true).length,
  };

  return {
    ref,
    dataUser,
    subMenu,
    setSubMenu,
    errMsg,
    successMsg,
    isScanning,
    stopScanner,
    sortedMesin,
    shiftPatrol,
    setShiftPatrol,
    mesinPick,
    setMesinPick,
    hasTrouble,
    toggleTrouble,
    troubleType,
    setTroubleType,
    troubleDesc,
    setTroubleDesc,
    handlePickLaporan,
    handleSubMenuHistoryPatrol,
    historyRows,
    summary,
    shiftHistoryPatrol,
    setShiftHistoryPatrol,
    mesinPatrol,
    setMesinPatrol,
    datePatrolQc,
    setDatePatrolQc,
    onlyTrouble,
    setOnlyTrouble,
    resetHistoryFilter,
    isFilterChanged,
  };
};
